import React, {useEffect, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Fade, Menu, MenuItem, styled} from "@mui/material";
import {DateRangePicker} from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {convertDateToString} from "../utils/cert-helper";
import ShowSnackbar from "../utils/ShowSnackbar";
import SearchIcon from '@mui/icons-material/Search';
import {getQueryString} from "../utils/http-helpers";
import RefreshIcon from '@mui/icons-material/Refresh';
import {useDispatch, useSelector} from "react-redux";
import {closeAllHispsErrorSnackbar, getAllHisps} from "../features/allHispsSlice";
import {CustomBackdrop, customRangeLabels} from "../utils/customStyles";
import {ApiUrl} from "../utils/portal-urls";

export const StyledQueryDiv = styled('div')({
    display: 'flex',
    gap: '10px',
    marginBottom: '5px',
    '& .Mui-disabled': {
        opacity: '50%'
    }
})
export const StyledSearchDiv = styled('div')({
    display: 'flex',
    gap: '15px',
    '& .exportButton': {
        marginLeft: 'auto',
    }
})
const StyledDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        maxWidth: '1000px',
    }
})

export default function ContributionSearchPanel(props) {

    // const hisps = props.hisps;
    const onQueryStringChanged = props.onQueryStringChanged;
    const onRefresh = props.onRefresh;
    const setPage = props.setPage;
    const exportQuery = props.exportQuery

    const [params, setParams] = useState({});
    const [queryString, setQueryString] = useState("");

    const [hispAnchorEl, setHispAnchorEl] = useState(null);
    const [hispName, setHispName] = useState("SELECT A HISP")
    const [acceptedAnchorEl, setAcceptedAnchorEl] = useState(null);
    const [accepted, setAccepted] = useState("SELECT ACCEPTED OR REJECTED");
    const [lastPublishedContributionsAnchorEl, setLastPublishedContributionsAnchorEl] = useState(null)
    const [showLastPublished, setShowLastPublished] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg:'', msgLv: ''});
    const [loading, setLoading] = useState(false);


    // react redux
    const { hisps, allHispsError, allHispsErrorMessage } = useSelector(state => state.allHisps);
    const dispatch = useDispatch();


    const hispOpen = Boolean(hispAnchorEl);
    const acceptedOpen = Boolean(acceptedAnchorEl);
    const lastPublishedContributionsOpen = Boolean(lastPublishedContributionsAnchorEl);

    const [dateRange, setDateRange] = useState({
        startDate: "",
        endDate: "",
    });
    const [state, setState] = useState([
        {
            startDate: null,
            endDate: new Date(""),
            key: 'selection'
        }
    ]);

    useEffect(() => {
        console.log("useEffect, query String updated: ", queryString);
        onQueryStringChanged(queryString);
    }, [queryString])

    useEffect(() => {
        dispatch(getAllHisps());
    }, [])

    const handleHispClose = (event) => {
        const value = event.target.id;
        const newParams = {...params};
        if (value === "" || value === "close") {
            setHispName("SELECT A HISP");
            if (newParams.hisp !== undefined) {
                delete newParams.hisp;
            }
        } else {
            setHispName(value);
            newParams.hisp = value;
        }
        setParams(newParams);
        setHispAnchorEl(null);
    };

    const handleLastPublishedContributions = (event) => {
        const value = event.target.id;
        const newParams = {...params}
        if (value === "") {
            setShowLastPublished(false)
            if (newParams.lastPublished !== undefined) {
                delete newParams.lastPublished;
            }
        } else {
            if (value === 'true') {
                if (newParams.accepted !== undefined) {
                    delete newParams.accepted;
                    setAccepted("Select Accepted or Rejected");
                }
                if (newParams.startDate !== undefined || newParams.endDate !== undefined) {
                    delete newParams.startDate;
                    delete newParams.endDate;
                    setDateRange({startDate: "", endDate: ""});
                    setState([
                        {
                            startDate: null,
                            endDate: new Date(""),
                            key: 'selection'
                        }
                    ])
                }
                setShowLastPublished(true)
                newParams.lastPublished = true;
            } else {
                setShowLastPublished(false);
                newParams.lastPublished = false;
            }
        }
        setParams(newParams);
        setLastPublishedContributionsAnchorEl(null);
    }

    const handleAcceptedClose = (event) => {
        const value = event.target.id;
        console.info(event)
        const newParams = {...params};
        if (value === "" || value === "SELECT ACCEPTED OR REJECTED") {
            setAccepted("SELECT ACCEPTED OR REJECTED");
            if (newParams.accepted !== undefined) {
                delete newParams.accepted;
            }
        } else {
            setAccepted(value);
            newParams.accepted = (value === "accepted");
        }

        setParams(newParams);
        setAcceptedAnchorEl(null);
    }

    const handleDateChange = (item) => {
        const newParams = {...params};
        setState([item.selection]);
        setDateRange({
            startDate: convertDateToString(item.selection.startDate),
            endDate: convertDateToString(item.selection.endDate),
        })

        if (item === "") {
            if (params.startDate !== undefined || params.endDate !== undefined) {
                delete params.startDate;
                delete params.endDate;
            }
        } else {
            newParams.startDate = convertDateToString(item.selection.startDate);
            newParams.endDate = convertDateToString(item.selection.endDate);
        }
        setParams(newParams);
    }

    const handleSearch = () => {
        setPage(0);
        const s = getQueryString(params);
        console.log("search ", params, s);
        setQueryString(s);
    }

    const handleDateRangePickerReset = () => {
        const newParam = {...params}
        setDateRange({
            startDate: "",
            endDate: "",
        })
        setState([
            {
                startDate: null,
                endDate: new Date(""),
                key: 'selection'
            }
        ])
        delete newParam.startDate;
        delete newParam.endDate;

        setParams(newParam);
    }

    const handleResetClick = () => {
        setPage(0);
        setParams({});
        setQueryString(getQueryString({}));
        setHispName("SELECT A HISP");
        setAccepted("SELECT ACCEPTED OR REJECTED");
        setDateRange({startDate: "", endDate: ""});
        setShowLastPublished(false);
        setState([
            {
                startDate: null,
                endDate: new Date(""),
                key: 'selection'
            }
        ])
    }

    const handleRefresh = () => {
        onRefresh(new Date().getTime());
    }

    return (
        <div>
            <StyledQueryDiv>
                <StyledDialog
                    open={dialogOpen}
                    onClose={handleHispClose}
                >
                    <DialogTitle>{"Please select a date range"}</DialogTitle>
                    <DialogContent>
                        <DateRangePicker
                            onChange={item => handleDateChange(item)}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={2}
                            ranges={state}
                            staticRanges={customRangeLabels}
                            direction="horizontal"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDateRangePickerReset} variant='outlined'>RESET</Button>
                        <Button onClick={() => setDialogOpen(false)} variant='contained'>Confirm</Button>
                    </DialogActions>
                </StyledDialog>
                <Button
                    id="hisps-button"
                    aria-controls={hispOpen ? 'hisps-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={hispOpen ? 'true' : undefined}
                    onClick={(event) => setHispAnchorEl(event.currentTarget)}
                    variant="text"
                    endIcon={<KeyboardArrowDownIcon/>}
                >
                    {hispName}
                </Button>
                <Menu
                    id="hisps-menu"
                    anchorEl={hispAnchorEl}
                    open={hispOpen}
                    onClose={handleHispClose}
                    MenuListProps={{
                        'aria-labelledby': 'hisps-button',
                    }}
                    TransitionComponent={Fade}
                >
                    <MenuItem id='close' onClick={handleHispClose}>Select a Hisp</MenuItem>
                    {hisps && hisps.map( hisp => (
                        <MenuItem id={hisp.hispId} key={hisp.hispId} onClick={handleHispClose}>{hisp.hispName}</MenuItem>
                    ))}
                </Menu>

                <Button
                    id="accepted-button"
                    aria-controls={acceptedOpen ? 'accepted-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={acceptedOpen ? 'true' : undefined}
                    onClick={(event) => setAcceptedAnchorEl(event.currentTarget)}
                    variant="text"
                    endIcon={<KeyboardArrowDownIcon/>}
                    disabled={showLastPublished}
                    sx={{ color: showLastPublished ? '50%' : '100%'}}
                >
                    {accepted}
                </Button>
                <Menu
                    id="accepted-menu"
                    anchorEl={acceptedAnchorEl}
                    open={acceptedOpen}
                    onClose={handleAcceptedClose}
                    TransitionComponent={Fade}
                    MenuListProps={{
                        'aria-labelledby': 'accepted-button',
                    }}
                >
                    <MenuItem id="SELECT ACCEPTED OR REJECTED" onClick={handleAcceptedClose}>SELECT ACCEPTED OR REJECTED</MenuItem>
                    <MenuItem id="accepted" onClick={handleAcceptedClose}>Accepted</MenuItem>
                    <MenuItem id="rejected" onClick={handleAcceptedClose}>Rejected</MenuItem>
                </Menu>
                <Button
                    onClick={() => setDialogOpen(true)}
                    variant="text"
                    disabled={showLastPublished}
                    endIcon={<KeyboardArrowDownIcon/>}
                >
                    {dateRange.startDate !== "" ? `${dateRange.startDate} - ${dateRange.endDate}` : "Select a date range"}
                </Button>
                <Button
                    variant='text'
                    onClick={(event) => setLastPublishedContributionsAnchorEl(event.currentTarget) }
                    endIcon={<KeyboardArrowDownIcon/>}
                    id="lastPublishedContribution-button"
                    aria-controls={lastPublishedContributionsOpen ? 'lastPublishedContribution-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={lastPublishedContributionsOpen ? 'true' : undefined}
                >
                    {showLastPublished ? <div>Show <b>LAST PUBLISHED</b> Contributions</div> : <div>Show <b>ALL</b> Contributions</div>}
                </Button>
                <Menu
                    open={lastPublishedContributionsOpen}
                    anchorEl={lastPublishedContributionsAnchorEl}
                    id="lastPublishedContribution-menu"
                    onClose={handleLastPublishedContributions}
                    TransitionComponent={Fade}
                    MenuListProps={{
                        'aria-labelledby': 'lastPublishedContribution-button',
                    }}
                >
                    <MenuItem id="true" onClick={handleLastPublishedContributions}>Show LAST PUBLISHED Contributions</MenuItem>
                    <MenuItem id="false" onClick={handleLastPublishedContributions}>Show ALL Contributions</MenuItem>
                </Menu>

            </StyledQueryDiv>

            <StyledSearchDiv>
                <Button variant='contained' onClick={handleSearch} startIcon={<SearchIcon/>}>
                    Search
                </Button>
                <Button variant='outlined' onClick={handleRefresh} startIcon={<RefreshIcon />}>
                    Refresh
                </Button>
                <Button variant='outlined' onClick={handleResetClick}>
                    Reset
                </Button>
                <Button variant='contained' className='exportButton' href={ApiUrl.Contributions.contributionExport.getPath(exportQuery)} target='_blank'>
                    Export
                </Button>
            </StyledSearchDiv>
            {allHispsError &&
                <ShowSnackbar open={allHispsError} close={() => dispatch(closeAllHispsErrorSnackbar())}
                              msg={{msgLv: 'error', msg: `${allHispsErrorMessage}`}}/>}
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={loading} />
        </div>
    )
}
